import { Component, OnInit, ElementRef, Renderer2 } from '@angular/core';
import { ApiService } from '../../shared/api-service/api.service';
import { AuthService } from '../../shared/auth/auth.service';
import { Logging } from '../../logging';
import { logging } from 'protractor';


declare var jquery:any;
declare var $ :any;
declare var App:any;
declare var FormSliderSwitcher:any;

@Component({
  selector: 'app-main-dashaccount-list',
  templateUrl: './main-dashaccount-list.component.html',
  styleUrls: []
})
export class MainDashaccountListComponent implements OnInit {

  loading: boolean;
  translist: any[];
  constructor(private api: ApiService,
    private auth: AuthService) { }

  ngOnInit() {
    this.getData();
  }

  getData()
  {
      this.loading = true;
      //Fetch all users
      this.api.get('/accounts/'+ this.auth.getAccountID() + '/balancedetails')
      .subscribe(
        res_data => {
        Logging.log(res_data.data);
        this.translist = res_data.data;
        this.prepareData();
        this.loading = false;
        }, error_message => {
          this.loading = false;
         //  this.hasError = true;
         //  this.errorMessage = error_message;
        }
      );
    }


    prepareData()
    {
      if(this.translist.length < 2)
      {
        $('#dashasctlist').hide();
        return;
      }

     const self = this;
   //  const raws = Math.ceil(this.translist.length/4);
    // const mod = this.translist.length % 4;

     const col = (this.translist.length >= 4 ) ? 3 : (this.translist.length == 3) ? 4 : 6;
     const rcmax = (col == 3) ? 4 : (col == 4) ? 3 : 2;
   
     var ele = "";
     let closediv = false;

     for(let i=0,rc=1;i<this.translist.length;i++,rc++)
     {
    
       if(rc == 1 )
       {
          closediv = true;
          ele +='<div class="row">';
       }

        ele +="<div class='col-md-"+col+"'>";
        ele +='<div class="panel panel-default add-shadow">';
        ele +='<div class="panel-heading">';
       // ele += '<div class="panel-heading-btn">';
       // ele += '<a href="javascript:;" class="btn btn-xs btn-icon btn-circle btn-warning" data-click="panel-collapse"> <i class="fa fa-minus"></i> </a>';
      //  ele += '</div>';
        ele +='<h4 class="panel-title">'+ this.translist[i].appname +'</h4>';
        ele +='<div class="panel-body">';
        ele += '<p class="text-center lead stats-number"><strong>GHS '+this.translist[i].availablebalance.toLocaleString() + '</strong></p>';

        ele +='</div></div></div></div>';

        if(rc == rcmax)
        {
          ele +='</div>';
          rc = 1;
          closediv = false;
        }
     }

     if(closediv)
     {
      ele +='</div>';
     }

     Logging.log(ele);
     //$('#target').append(ele);
     $('#target').html(ele);

    }
}



// WEBPACK FOOTER //
// ./src/app/client/main-dashaccount-list/main-dashaccount-list.component.ts